define('apps/course-intro/views/regions/materials/content',[
    'apps/course-intro/templates/regions/materials/content',
    'components/transition/transition',
    'apps/course-intro/templates/regions/materials/level',
    'apps/course-intro/templates/regions/materials/module',
    'apps/course-intro/templates/regions/materials/asset',
    'components/course/models/materials-page',
    'components/asset-player/radio-channel'
], function(template, Transition, LevelTemplate, Moduletemplate, AssetTemplate, MaterialsPageModel, PlayerChannel) {
    "use strict";

    return Mn.ItemView.extend({
        "isDataEmpty": false,

        "template": template,

        "windowConfig": {
            "VIDEO": {
                "width": 600,
                "height": 500
            },
            "PDF": {
                "width": 600,
                "height": 1000
            }
        },

        "events": {
            "click .back-top": "onBackTopClick",
            "click .asset-holder": "onAssetClick"
        },

        "onShow": function() {
            this._onLoadComplete();
            Transition.create({
                "direction": Transition.Direction.DOWN,
                "context": this,
                "el": $('h1', this.el),
                "type": Transition.Type.FADE_IN,
                "duration": 1.2
            }).start();
        },

        "onRender": function() {
            var materialsData = this.model.get('levels').models[parseInt(this.model.get('currentPage').levelNum, 10) - 1].get('materialsData');

            if (materialsData) {

                this.levelData = materialsData.levelData;
                this._renderLevel();
            } else {
                this.isDataEmpty = true;
                this.$('.empty-materials-page-content, .materials-page-content').toggleClass('hide');
            }
            // Need this event for tabs, Nexus and other device for portrait and landscape mode.
            window.addEventListener('orientationchange', _.bind(this._orientationChangedHandler, this));
            this.$('.materials-page-content').off('load.completed').on('load.completed', _.bind(this._onLoadComplete, this));
        },

        "_onLoadComplete": function() {
            if (this.isDataEmpty) {
                return;
            }
            var counter = 1,
                limit = this.$('.module').length,
                $aseets = this.$('.module-asset .asset-holder'),
                $newAsset;

            $aseets.css('height', '');
            for (; counter <= limit; counter++) {
                $newAsset = $aseets.filter(function() {
                    return $(this).data("module") === counter;
                });
                this._adjustAssetHeight($newAsset);
            }
        },

        "_orientationChangedHandler": function() {
            this._onLoadComplete();
        },

        "_adjustAssetHeight": function($assets) {
            var index = 0,
                limit = $assets.length,
                $firstEle,
                $secondEle,
                secondEleTop,
                firstEleHeight,
                secondEleHeight;

            for (; index < limit - 1; index++) {
                $firstEle = $assets.eq(index);
                $secondEle = $assets.eq(index + 1);
                secondEleTop = $secondEle.offset().top;
                firstEleHeight = $firstEle.height();
                secondEleHeight = $secondEle.height();

                if ($firstEle.offset().top === secondEleTop) {
                    this._setAssetHeightWithSameTop($assets, secondEleTop, firstEleHeight > secondEleHeight ? firstEleHeight : secondEleHeight);
                }
            }
        },

        "_setAssetHeightWithSameTop": function($assets, top, height) {
            var $newAsset = $assets.filter(function() {
                return $(this).offset().top === top;
            });

            $newAsset.height(height);
        },

        "_renderLevel": function() {
            _.each(this.levelData, function(level, index) {
                this.$('.materials-page-content').append(LevelTemplate(
                    _.extend({
                        "index": index
                    }, level)));
                this.$('.level-asset.asset-holder').data({
                    "asset-type": level.levelAssets[0].type.toUpperCase(),
                    "asset-url": level.levelAssets[0].assetData.url
                });
                this._renderModules(level);
            }, this);
        },

        "_renderModules": function(level) {
            var moduleIconData;

            _.each(level.modules, function(module, index) {
                moduleIconData = module.moduleIconData;
                this.$('.level-wrapper').append(Moduletemplate({
                    "index": index + 1, // Module number starts from 1
                    "moduleTitle": module.moduleTitle
                }));
                this._renderAsset(module, index + 1); // Module number starts from 1
                moduleIconData &&
                    this._renderIcon(_.extend({
                        "layout": "background"
                    }, moduleIconData), this.$('.module-' + (index + 1) + ' .module-icon'));
            }, this);
            this.$('.level-wrapper').append($('<div>', {
                "class": "clear-div"
            }));
        },

        "_renderAsset": function(module, moduleIndex) {
            var $parent = this.$('.module-' + moduleIndex).parent(),
                assetType;

            _.each(module.moduleAssets, function(asset, index) {
                assetType = asset.typeDetails.type;
                $parent.append(AssetTemplate(
                    _.extend({
                        "index": index,
                        "type": assetType.toLowerCase(),
                        "isPdf": assetType === MaterialsPageModel.MODULE_ASSET_TYPE.PDF.TYPE
                    }, asset)
                ));
                this._renderAssetIcon(asset, $parent.find('.module-asset-' + index + ' .module-asset-thumb'));
                $parent.find('.module-asset-' + index + ' .asset-holder').data({
                    "asset-type": assetType,
                    "asset-url": asset.assetData.url,
                    "module": moduleIndex
                });
            }, this);

            $parent.find('.module-asset').data({
                "module": moduleIndex
            });
        },

        "_renderAssetIcon": function(asset, $target) {
            var type = asset.type || asset.typeDetails.type;

            if (type === MaterialsPageModel.MODULE_ASSET_TYPE.VIDEO.TYPE && asset.videoThumbnail) {
                this._renderIcon({
                    "assetGuid": asset.videoThumbnail.assetGuid,
                    "typeId": asset.videoThumbnail.typeId,
                    "layout": "background"
                }, $target);
            }
        },

        "_renderIcon": function(data, $target) {
            $target.removeClass('player-loaded')
                .addClass('player-asset').data({
                    "guid": data.assetGuid,
                    "type-id": data.typeId,
                    "layout": data.layout || ''
                });
            PlayerChannel.command(PlayerChannel.Event.RENDER, {
                "target": this.$el
            });

        },

        "onBackTopClick": function() {
            $(window).scrollTop(0);
        },

        "onAssetClick": function(event) {
            var $target = $(event.currentTarget),
                ASSET_TYPES = MaterialsPageModel.MODULE_ASSET_TYPE,
                assetData = $target.data(),
                type = assetData['asset-type'],
                assetURL = '',
                config = this._getWindowConfig(type),
                html,
                eventAction = '',
                eventCategory = '',
                eventLabel = '';

            switch (type) {
                case ASSET_TYPES.PDF.TYPE:
                    assetURL = assetData['asset-url'];
                    eventAction = 'click-pdf';
                    eventCategory = 'download';
                    eventLabel = assetData['asset-url'];
                    break;
                case ASSET_TYPES.VIDEO.TYPE:
                    html = '<video controls style="width: 100%;"><source src="' + assetData['asset-url'] + '" /></video>';
                    eventAction = 'video loaded';
                    eventCategory = 'video';
                    eventLabel = $target.find('.module-asset-title').text();
                    break;
            }

            if (config) {
                gtag('event', eventAction, {
                    'event_category': eventCategory,
                    'event_label': eventLabel
                });
                this.assetWindow = window.open(assetURL, '', config);
                html && this.assetWindow.document.write(html);
            }
        },

        "_getWindowConfig": function(type) {
            var configObj = this.windowConfig[type],
                configString,
                left,
                top;

            if (!configObj) {
                return false;
            }

            top = (window.screen.height - configObj.height) / 2;
            left = (window.screen.width - configObj.width) / 2;

            configString = 'width=' + configObj.width + ',height=' + configObj.height +
                ',location=1,scrollbars=1' +
                ',screenY=' + top +
                ',screenX=' + left +
                ',top=' + top +
                ',left=' + left;

            return configString;
        }
    });
});

